// extracted by mini-css-extract-plugin
export default {"tooltip":"zW-z","arrow":"AW-z"};